import React from 'react';
import {View, Text, FlatList, StyleSheet} from 'react-native';

const defaultKeyExtractor = (item, index) => {
  const id = item?.product_id ?? item?.item_id ?? item?.id ?? '';
  return `${id}-${index}`;
};

const ScrollableItemList = ({
  items = [],
  renderItem,
  emptyText = 'No items',
  header,
  footer,
  keyExtractor
}) => {
  const renderEmpty = () => (
    <View style={styles.emptyContainer}>
      <Text style={styles.emptyText}>{emptyText}</Text>
    </View>
  );

  return (
    <FlatList
      style={styles.container}
      contentContainerStyle={items.length === 0 ? styles.emptyContent : null}
      data={items}
      keyExtractor={keyExtractor || defaultKeyExtractor}
      renderItem={({item, index}) => renderItem(item, index)}
      ListHeaderComponent={header || null}
      ListFooterComponent={footer || null}
      ListEmptyComponent={renderEmpty}
      showsVerticalScrollIndicator={false}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  emptyContent: {
    flexGrow: 1
  },
  emptyContainer: {
    padding: 20,
    alignItems: 'center'
  },
  emptyText: {
    color: '#fff',
    fontSize: 16
  }
});

export default ScrollableItemList;
